module.exports = __webpack_public_path__ + "static/media/buy_history_2.a140b87d.jpg";